export function formatBucketSlug(bucket: string): string {
    return bucket
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}
